import { render } from "./Slots.vue?vue&type=template&id=22054d44&scoped=true&ts=true"
import script from "./Slots.vue?vue&type=script&lang=ts"
export * from "./Slots.vue?vue&type=script&lang=ts"

import "./Slots.vue?vue&type=style&index=0&id=22054d44&scoped=true&lang=css"

import exportComponent from "/Users/asaskevich/Work/sequoia-cabinet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22054d44"]])

export default __exports__